import { createAction } from 'typesafe-actions';

export const acknowledgePickTour = createAction('ACKNOWLEDGE_PICK_TOUR')<{
  pickTourID: string;
}>();
